import React from "react";

export type KpiAccent = "blue" | "fuchsia" | "green" | "orange";

interface Props {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
  changePct?: number | null;
  direction?: "up" | "down" | "flat";
  accent: KpiAccent;
  blocked?: boolean;
  onClick?: () => void;
}

const ACCENT: Record<KpiAccent, { iconBg: string; iconColor: string; underline: string }> = {
  blue:    { iconBg: "bg-blue-100",    iconColor: "text-blue-600",    underline: "bg-blue-500"    },
  fuchsia: { iconBg: "bg-fuchsia-100", iconColor: "text-fuchsia-600", underline: "bg-fuchsia-500" },
  green:   { iconBg: "bg-green-100",   iconColor: "text-green-600",   underline: "bg-green-500"   },
  orange:  { iconBg: "bg-orange-100",  iconColor: "text-orange-600",  underline: "bg-orange-500"  },
};

export const KpiCardComponent: React.FC<Props> = ({
  icon, label, value, changePct, direction, accent, blocked, onClick,
}) => {
  const a = ACCENT[accent];
  const arrow = direction === "up" ? "↗" : direction === "down" ? "↘" : "→";
  const changeColor =
    direction === "up" ? "text-green-600" :
    direction === "down" ? "text-red-500" :
    "text-slate-400";

  return (
    <div
      onClick={onClick}
      className={`relative overflow-hidden rounded-2xl bg-white border border-slate-100 shadow-sm p-5${onClick ? " cursor-pointer hover:border-blue-300 hover:shadow-md transition-all" : ""}`}
    >
      <div className="flex items-start justify-between">
        <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${a.iconBg} ${a.iconColor}`}>
          {icon}
        </div>
        {!blocked && changePct !== null && changePct !== undefined && (
          <span className={`text-xs font-semibold flex items-center gap-0.5 ${changeColor}`}>
            <span>{arrow}</span>
            <span>{Math.abs(changePct).toFixed(1)}%</span>
          </span>
        )}
        {blocked && (
          <span className="text-[10px] font-medium uppercase tracking-wide text-slate-400 bg-slate-100 px-2 py-0.5 rounded-full">
            Coming soon
          </span>
        )}
      </div>
      <p className="mt-6 text-xs font-medium text-slate-500">{label}</p>
      <p className="mt-1 text-2xl font-bold text-slate-900">
        {blocked ? "—" : value}
      </p>
      <div className={`absolute left-0 bottom-0 h-1 w-full ${a.underline} opacity-90`} />
    </div>
  );
};

export default KpiCardComponent;
